import { render, staticRenderFns } from "./ShrimpDiseaseMap.vue?vue&type=template&id=7440160c&"
import script from "./ShrimpDiseaseMap.vue?vue&type=script&lang=js&"
export * from "./ShrimpDiseaseMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports